import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "note-enhancing-overlay-wrapper" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "text-sm text-text-default font-medium" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import useTranslate from '@/utilities/composables/useTranslate';

const WORD_UPDATE_RATE = 3000;


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteEnhancingOverlay',
  props: {
    finished: {},
    transcriptAvailable: { type: Boolean }
  },
  setup(__props: any) {

const { translate } = useTranslate();

const props = __props;

const enhancingIntervalId = ref<ReturnType<typeof setInterval> | null>();
const noteEnhancingOverlay = ref();
const currentEnhancedTextIndex = ref(0);

const enhancingTextList = computed(() => {
  const textList = props.transcriptAvailable
    ? [translate('analysingTranscript'), translate('comparingYourNotes')]
    : [translate('readingYourNotes')];

  return textList.concat([translate('enhancingYourNotes')]).map((text) => `${text}...`);
});

const displayText = computed(() => {
  return props.finished ? translate('finished') : enhancingText.value;
});

const enhancingText = ref(enhancingTextList.value[currentEnhancedTextIndex.value]);

const updateEnhancingText = async () => {
  clearEnhancingInterval();

  if (currentEnhancedTextIndex.value === enhancingTextList.value.length - 1) {
    return;
  }

  currentEnhancedTextIndex.value = currentEnhancedTextIndex.value + 1;
  enhancingText.value = enhancingTextList.value[currentEnhancedTextIndex.value];

  setupEnhancingInterval();
};

const setupEnhancingInterval = () => {
  enhancingIntervalId.value = setInterval(updateEnhancingText, WORD_UPDATE_RATE);
};

const clearEnhancingInterval = () => {
  clearInterval(enhancingIntervalId.value!);
  enhancingIntervalId.value = null;
};

onMounted(() => {
  setupEnhancingInterval();
});

onBeforeUnmount(() => {
  clearEnhancingInterval();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "noteEnhancingOverlay",
      ref: noteEnhancingOverlay,
      class: _normalizeClass(["note-enhancing-overlay", { 'rotating-overlay': !props.finished, 'pop-animation': props.finished }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(displayText.value), 1)
      ])
    ], 2)
  ]))
}
}

})